import { useState } from "react"

const labels = {
    "IT": {
        "communicationProjects": {
            LabelSingular:'Project',
            LabelPlural:"Projects"
        } 
    },
    "Restuarant":{
        "communicationProjects": {
            LabelSingular:'Restuarant',
            LabelPlural:"Restuarants"
        } 
    }
}

const useWorkSpaceLabel = () => {

    const [workSpaceLabels, setWorkSpaveLabels] = useState(labels.Restuarant)

    return {
        workSpaceLabels,
        setWorkSpaveLabels,
    }

}

export default useWorkSpaceLabel
